
<div class="container-fluid p-2 bg-white">
    <div class="container-fluid p-2" style="background-color: #F2F5F9;">
        <app-vca *ngIf="code == 'PS00577'"></app-vca>
        <app-vcn *ngIf="code == 'PS00035'"></app-vcn>
        <app-vri *ngIf="code == 'PS00565'"></app-vri>
        <app-dam *ngIf="code == 'PS00569'"></app-dam>

    </div>
</div>